// ============================================================================
// QUOTE CREATE STATE
// Used for creating new regular quotes
// ============================================================================

export interface QuoteCreateState {
    creating: boolean;
}

export const initialQuoteCreateState: QuoteCreateState = {
    creating: false,
};
